import { render, staticRenderFns } from "./fccDataTipoPublicacao.vue?vue&type=template&id=66d650b9"
import script from "./fccDataTipoPublicacao.vue?vue&type=script&lang=js"
export * from "./fccDataTipoPublicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports